import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import {
    withStyles,
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    TextField,
    Button,
    Menu,
    MenuItem,
    Select
} from '@material-ui/core';
import Moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import PropTypes from 'prop-types';
import invoiceApi from '../../../api/InvoiceApi';
import AuthApi from '../../../api/AuthApi';
import { useReactToPrint } from 'react-to-print';

import practitionerApi from '../../../api/PractitionerApi';
import { getClinic } from '../../../api/ClinicApi';
import { INVOICE_PAYMENT_STATUS, INVOICE_ORIGIN, INVOICE_PAYMENT_TYPES } from '../../../../collums-constants/index';
import { InvoiceModalStyles } from './styles';
import { getCurrencySymbol, toLocaleString } from '../../../helpers/index';
import { Autocomplete } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
    roundTwoDecimals,
    getTotalsFromInvoiceItems,
    calculateTaxValue
} from '../../../../collums-constants/utils/index';
import LoadingScreen from '../loadingScreen';
import CancelContinueModal from '../CancelContinueModal';
import InvoiceApi from '../../../api/InvoiceApi';
import OrganisationApi from '../../../api/organizationApi';
import _ from 'lodash';
import EditableCell from './EditableCell';
import PaymentLinkDialog from './PaymentLinkDialog';
import XeroApi from '../../../../api/xeroApi';
import { DateTimePicker } from '@material-ui/pickers';
import DirectDebitModal from './DirectDebitModal';
import TaxesApi from '../../../api/TaxesApi';
import { MEDICAL_TYPES_COLOURS, MEDICAL_TYPES } from '../../../../collums-constants';
import SendInvoiceEmailModal from './SendInvoiceEmailModal';
import EditNoteModal from './EditNoteModal';

const itemsHeader = [
    { name: 'Sold By' },
    { name: 'Item' },
    { name: 'Medical' },
    { name: '#' },
    { name: 'Unit Price ex Tax', numeric: true },
    { name: 'Tax' },
    { name: 'Sub Total inc Tax', numeric: true },
    { name: 'Disc inc Tax', numeric: true },
    // { name: 'Net Price', numeric: true },
    { name: 'Tax Total', numeric: true },
    { name: 'Total', numeric: true }
];

const changeLogHeader = [{ name: 'Date' }, { name: 'By' }, { name: 'Note' }];

const paymentsHeader = [
    { name: 'Date/Time' },
    { name: 'Taken By' },
    { name: 'Method' },
    { name: 'Amount', numeric: true },
    { name: '' }
];

const blockedEditPaymentMethods = [
    INVOICE_PAYMENT_TYPES.CREDIT_CARD,
    INVOICE_PAYMENT_TYPES.CREDIT_CARD_TERMINAL,
    INVOICE_PAYMENT_TYPES.ACCOUNT_BALANCE,
    INVOICE_PAYMENT_TYPES.GIFTCARD
];

const InvoiceModal = ({ classes, invoice, closeInvoiceModal, loadInvoice, source, listUpdate, openRefundModal }) => {
    const [invoiceData, setInvoiceData] = useState({});
    // eslint-disable-next-line
    const [invoiceNote, setInvoiceNote] = useState('');
    const [newInvoiceNote, setNewInvoiceNote] = useState('');
    const [practitionerList, setPractitionerList] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [canEdit, setCanEdit] = useState(false);
    const [newValues, setNewValues] = useState({});
    const [activePractitioners, setActivePractitioners] = useState([]);
    const [voidPopupOpen, setVoidPopupOpen] = useState(false);
    const [voidOsPopupOpen, setVoidOsPopupOpen] = useState(false);
    const [referenceInvoice, setReferenceInvoice] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [modifiedsLogModel, setModifiedsLogModel] = useState(false);
    const [paymentLinkModel, setPaymentLinkModel] = useState(false);
    const [showDirectDebitModal, setShowDirectDebitModal] = useState(false);
    const [isXeroConnected, setIsXeroConnected] = useState(false);
    const componentRef = useRef();
    const [myClinics, setMyClinics] = useState([]);
    const [currentClinic, setCurrentClinic] = useState(null);
    const [unpaidPaymentLink, setUnpaidPaymentLink] = useState(false);
    const [isVat0Only, setIsVat0Only] = useState(false);
    const [showSendEmailModal, setShowSendEmailModal] = useState(false);
    const [editNoteModalOpen, setEditNoteModalOpen] = useState(false);
    const [editingNote, setEditingNote] = useState(null); // { noteType, noteId, description }
    const [deleteLastItemWarning, setDeleteLastItemWarning] = useState(false);

    // payment table states
    const [editPaymentAmountId, setEditPaymentAmountId] = useState(null);
    const [editPaymentMethodId, setEditPaymentMethodId] = useState(null);
    const [editPaymentTakenBy, setEditPaymentTakenBy] = useState(null);
    const [editPaymentDateId, setEditPaymentDateId] = useState(null);
    const [editSoldByItemId, setEditSoldByItemId] = useState(null);
    const [editTotalItemId, setEditTotalItemId] = useState(null);
    const [editQuantityItemId, setEditQuantityItemId] = useState(null);
    const [editTaxItemId, setEditTaxItemId] = useState(null);
    const [editUnitPriceItemId, setEditUnitPriceItemId] = useState(null);
    const [editDiscountItemId, setEditDiscountItemId] = useState(null);
    const [discountType, setDiscountType] = useState('amount'); // 'amount' (£) or 'percent' (%)
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [taxOptions, setTaxOptions] = useState([]);

    const [disabledButton, setDisabledButton] = useState(false);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const isFirstRender = useRef(true);

    const isRefundModalOpen = useSelector(state => state.invoice?.isInvoiceRefundModalOpen);

    const clearEditableFieldsState = () => {
        setEditPaymentAmountId(null);
        setEditPaymentMethodId(null);
        setEditPaymentTakenBy(null);
        setEditTotalItemId(null);
        setEditSoldByItemId(null);
        setEditQuantityItemId(null);
        setEditTaxItemId(null);
        setEditUnitPriceItemId(null);
        setEditDiscountItemId(null);
        setDiscountType('amount');
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }

        TaxesApi.listTaxes({ archived: true, active: false }).then(res => {
            setTaxOptions(
                res.map(el => {
                    return { value: el.rate / 100, label: el.name };
                })
            );
        });

        OrganisationApi.getOrg().then(res => {
            setIsVat0Only(res.isVat0Only);
            const options = res.paymentTypes
                .filter(paymentType => paymentType.active && !blockedEditPaymentMethods.includes(paymentType.name))
                .map(paymentType => ({
                    name: paymentType.name,
                    label: paymentType.label
                }));

            setPaymentOptions(options);
            setIsLoading(false);
        });

        XeroApi.isXeroActive().then(res => {
            setIsXeroConnected('isxeroactive', res?.data?.isConnected);
        });
    }, []);

    useEffect(() => {
        // event called on refund modal close.
        if (!isFirstRender.current && !isRefundModalOpen) {
            reload(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRefundModalOpen]);

    const reload = async (reset = false) => {
        if (!invoice.id) return;

        setIsLoading(true);
        const res = await invoiceApi.getInvoice(invoice.id, true, true);
        if (res?.referencedInvoice) {
            res.items = res.items.map(element => {
                const netPrice = element.netPrice ? element.netPrice * -1 : 0;
                const discount = Math.abs(element.discount);
                const refundedAmount = Math.abs(element.refundedAmount) * -1;
                return { ...element, netPrice, discount, refundedAmount };
            });
            setInvoiceData(res);
        } else {
            res.items = res.items.map(element => {
                const netPrice = element.netPrice ? element.netPrice : 0;
                const discount = (element.discount || 0) * -1;
                return { ...element, netPrice, discount };
            });
            setInvoiceData(res);
        }
        if (!reset) {
            setCanEdit(false);
            setNewValues({});
            setNewInvoiceNote('');
            clearEditableFieldsState();
        }
        const hasUnpaidPaymentLinks = (await invoiceApi.checkUnpaidPaymentLinks(invoice.id))?.result;
        if (hasUnpaidPaymentLinks) {
            setUnpaidPaymentLink(true);
        }

        practitionerApi.query().then(res => setPractitionerList(res.items));
        practitionerApi.listActivePractitioners().then(res => setActivePractitioners(res));

        const currentUser = await AuthApi.getMe();
        await practitionerApi.listPractitionerClinics(currentUser.id).then(res => {
            setMyClinics(res);
        });
        await getClinic(res.clinic).then(resp => {
            setCurrentClinic(resp);
        });

        setIsLoading(false);
    };

    useEffect(() => {
        if (!invoice.id) return;
        if (invoice.isInvoiceModalOpen) {
            reload();
        }
        // eslint-disable-next-line
    }, [invoice.id, invoice.isInvoiceModalOpen]);

    useEffect(() => {
        if (invoiceData) {
            setInvoiceNote(invoiceData.description);
        }
        // eslint-disable-next-line
    }, [invoiceData]);

    // calculate data to use on invoice summary
    const { invoiceSubTotal, invoiceTotal, invoiceTax, invoiceDiscount } = useMemo(() => {
        const items = canEdit ? newValues?.items : invoiceData?.items;
        if (!items) return { invoiceSubTotal: 0, invoiceTotal: 0, invoiceTax: 0, invoiceDiscount: 0 };
        return getTotalsFromInvoiceItems(items, '', invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.REFUND);
    }, [invoiceData, newValues, canEdit]);

    const paymentTotal = useMemo(() => {
        const paymentsData = canEdit ? newValues?.payments : invoiceData?.payments;
        if (!paymentsData) return 0;

        const payments = paymentsData.map(payment => payment.amount);
        return payments.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoiceData?.payments, newValues, canEdit]);

    const totalOutstandingAmount = useMemo(() => {
        return ((invoiceTotal || 0) - (paymentTotal || 0)).toFixed(2);
    }, [paymentTotal, invoiceTotal]);

    const handleClose = () => {
        setNewValues({});
        setCanEdit(false);
        setNewInvoiceNote('');

        clearEditableFieldsState();

        if (!referenceInvoice) closeInvoiceModal();
        else {
            openInvoice(referenceInvoice);
            setReferenceInvoice(undefined);
        }
    };
    const handleCloseMenu = () => setAnchorEl(null);

    const openInvoice = invoice => {
        loadInvoice(invoice);
    };

    const handleUpdateVoid = async () => {
        const currentUser = await AuthApi.getMe();
        await invoiceApi.updateInvoiceStatus(invoice.id, INVOICE_PAYMENT_STATUS.VOID, currentUser.data);
        await invoiceApi.getInvoice(invoice.id, false, true).then(setInvoiceData);
        if (source === 'calendar') {
            listUpdate();
        }
    };

    const handleRefund = async () => {
        openRefundModal();
        handleClose();
    };

    const handleResendToXero = async () => {
        await XeroApi.sendToXero(invoice.id);
        toastr.success('Invoice synced with Xero');
        await reload();
        handleClose();
    };

    const havePayments = () => {
        return (
            invoiceData.paymentStatus !== INVOICE_PAYMENT_STATUS.UNPAID &&
            invoiceData.paymentStatus !== INVOICE_PAYMENT_STATUS.VOID &&
            invoiceData.paymentStatus !== INVOICE_PAYMENT_STATUS.REFUND
        );
    };

    const updateInvoice = async () => {
        setDisabledButton(true);
        const invoiceId = newValues.id;

        let invoiceItems = [];
        let haveIncorrectNetPrice = false;
        if (isRefundOrRelated) {
            invoiceItems = newValues.items.map(item => {
                return { id: item.id, soldBy: item.soldBy?.id };
            });
        } else {
            invoiceItems = newValues.items.map(item => {
                return {
                    id: item.id,
                    quantity: item.quantity,
                    tax: item.tax,
                    soldBy: item.soldBy?.id,
                    netPrice: item.netPrice,
                    medical: item.medical,
                    discount: Math.abs(item.discount || 0)
                };
            });

            haveIncorrectNetPrice = invoiceItems.find(
                el => el?.netPrice === undefined || isNaN(el?.netPrice) || el?.netPrice === null
            );
        }

        const haveUndefined = invoiceItems.find(el => {
            const item = newValues.items.find(newValueItem => newValueItem.id === el.id);
            if (!item) {
                return true; // force error
            }

            return el.soldBy === undefined && item?.type !== 'Void';
        });

        const paymentsHasChanged =
            invoiceData.payments.some(data => {
                return newValues.payments.some(newValue => {
                    return data.id === newValue.id
                        ? newValue.amount !== data.amount ||
                              newValue.method !== data.method ||
                              newValue.createdAt !== data.createdAt ||
                              newValue.takenBy?.id !== data.takenBy?.id
                        : false;
                });
            }) || invoiceData.payments.length !== newValues.payments.length;

        let invoicePayments = [];
        if (paymentsHasChanged && !isRefundOrRelated) {
            invoicePayments = newValues.payments.map(item => {
                return {
                    id: item.id,
                    amount: item.amount,
                    method: item.method,
                    createdAt: item.createdAt,
                    takenBy: item.takenBy
                };
            });
        }

        if (haveUndefined) {
            toastr.error('Sold by cannot be blank');
            setDisabledButton(false);
            return;
        }

        if (haveIncorrectNetPrice) {
            toastr.error('Net price value is not valid');
            setDisabledButton(false);
            return;
        }

        try {
            await invoiceApi.updateInvoiceCC(invoiceId, {
                invoiceItems,
                invoicePayments,
                invoicePaymentsRemoved: newValues?.paymentsRemoved || [],
                invoiceItemsRemoved: newValues?.itemsRemoved || [],
                newInvoiceNote: newInvoiceNote || undefined
            });

            toastr.success('Invoice successfully updated');
            setDisabledButton(false);
            await reload();

            if (listUpdate) {
                listUpdate();
            }
        } catch (err) {
            if (typeof err === 'object') {
                if (err.data && err.data.message) {
                    toastr.error(err.data.message);
                    return;
                }
            }
            setDisabledButton(false);
            toastr.error('Something went wrong');
        }
    };

    const changeEdit = async (force = false) => {
        if (!force && invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.UNPAID) {
            window.location.href = `${JSON.parse(localStorage.getItem('linkCache')).posUrl}/sale?invoice=${
                invoiceData.id
            }`;
            return;
        }
        if (!canEdit) {
            await reload(true);
        }

        if (canEdit) {
            clearEditableFieldsState();
        }

        setNewValues(canEdit ? {} : invoiceData);
        setCanEdit(!canEdit);
        setNewInvoiceNote('');
    };

    const getClinicDetails = () => {
        return [
            currentClinic?.organisationName,
            currentClinic?.address?.line1,
            currentClinic?.address?.city,
            currentClinic?.address?.postcode,
            invoiceData?.organization?.vatNo ? 'VAT no:' + invoiceData?.organization?.vatNo : ''
        ]
            .filter(el => el)
            .join(', ');
    };

    // used when it's not on CC
    const getCustomerName = customer => {
        return (
            <a
                target={'_blank'}
                rel="noopener noreferrer"
                href={`${JSON.parse(localStorage.getItem('linkCache')).calendarUrl}/customer/${customer?.id}/general`}
                style={{ color: '#0000EE', textDecoration: 'underline', cursor: 'pointer' }}
            >
                {customer?.firstName || ''} {customer?.surname || ''}
            </a>
        );
    };

    const colors = ['#1565C0', '#303F9F', '#512DA8', '#00695C'];

    const handleNoteClick = (noteType, noteId, description) => {
        if (!canEdit) return;
        setEditingNote({ noteType, noteId, description });
        setEditNoteModalOpen(true);
    };

    const handleNoteUpdate = async ({ noteType, noteId, newDescription }) => {
        try {
            setIsLoading(true);
            await invoiceApi.updateInvoiceNote(invoiceData.id, {
                noteType,
                noteId,
                description: newDescription
            });
            toastr.success('Note updated successfully');
            setEditNoteModalOpen(false);
            setEditingNote(null);
            await reload(true);
        } catch (err) {
            if (err?.data?.message) {
                toastr.error(err.data.message);
            } else {
                toastr.error('Failed to update note');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteItem = itemId => {
        setNewValues(prev => {
            const items = [...prev.items].filter(el => el.id !== itemId);

            if (
                items.length === 0 &&
                (invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.PAID ||
                    invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.PART_PAID)
            ) {
                setDeleteLastItemWarning(true);
                return prev;
            }

            const itemsRemoved = prev.itemsRemoved ? [...prev.itemsRemoved] : [];
            itemsRemoved.push(itemId);

            return {
                ...prev,
                items,
                itemsRemoved
            };
        });
    };

    const RenderShortNotes = () => {
        const modifies = invoiceData.modifies ? [...invoiceData.modifies] : [];
        if (invoiceData.description && invoiceData.description !== 'Invoice from POS') {
            modifies.unshift({
                description: invoiceData.description,
                date: invoiceData.createdAt,
                _isMainDescription: true
            });
        }
        if (!modifies.length) return <></>;

        // const SeeMoreBtn = () => (
        //     <b
        //         style={{ color: '#15F' }}
        //         onClick={e => {
        //             e.stopPropagation();
        //             setModifiedsLogModel(true);
        //         }}
        //     >
        //         ... see more
        //     </b>
        // );

        function shortNote(note) {
            return <>{note.description}</>;
        }

        const mapShortNotes = modifies.map((note, i) => {
            const color = i >= colors.length ? colors[i % 4] : colors[i];
            const noteType = note._isMainDescription ? 'description' : 'modify';
            const noteId = note._isMainDescription ? null : note.id;
            const clickableStyle = canEdit ? { cursor: 'pointer', textDecoration: 'underline' } : {};

            return (
                <Typography
                    style={{ color, whiteSpace: 'pre-line', ...clickableStyle }}
                    key={i + '-note-key'}
                    onClick={canEdit ? () => handleNoteClick(noteType, noteId, note.description) : undefined}
                >
                    {note.modifiedBy && <b>{note.modifiedBy.displayName}:</b>} {shortNote(note)}
                </Typography>
            );
        });
        return <Box>{mapShortNotes}</Box>;
    };
    const RenderPrintNotes = () => {
        const modifies = invoiceData.modifies ? [...invoiceData.modifies] : [];
        if (invoiceData.description && invoiceData.description !== 'Invoice from POS') {
            modifies.unshift({ description: invoiceData.description, date: invoiceData.createdAt });
        }
        if (!modifies.length) return <></>;

        function shortNote(note) {
            if (note.description.length < 60) return <>{note.description}</>;
            return <span>{note.description}</span>;
        }

        const mapShortNotes = modifies.map((note, i) => {
            const color = i >= colors.length ? colors[i % 4] : colors[i];

            return (
                <Typography style={{ color, whiteSpace: 'pre-line' }} key={i + '-note-key'}>
                    {shortNote(note)}
                </Typography>
            );
        });
        return <Box>{mapShortNotes}</Box>;
    };

    const RenderLogTableRows = () => {
        let modifiesMap = invoiceData?.modifies ? [...invoiceData?.modifies] : [];
        if (invoiceData.description && invoiceData.description !== 'Invoice from POS') {
            modifiesMap.unshift({
                description: invoiceData.description,
                date: invoiceData.createdAt,
                _isMainDescription: true
            });
        }
        const logs = [...modifiesMap, ...(invoiceData?.invoiceLogs || [])];
        logs.sort((a, b) => {
            return new Date(a?.date) - new Date(b?.date);
        });

        return logs
            .map((change, i) => {
                // Determine if this is an editable note (not a system log from invoiceLogs)
                const isEditableNote = change._isMainDescription || (change.id && !change.practitioner);
                const noteType = change._isMainDescription ? 'description' : 'modify';
                const noteId = change._isMainDescription ? null : change.id;
                const clickableStyle =
                    canEdit && isEditableNote ? { cursor: 'pointer', textDecoration: 'underline' } : {};

                return (
                    <TableRow key={i + '-log-table-key'}>
                        <TableCell className={classes.tableBodyCell}>
                            {Moment(change.date).format('DD/MM/YY HH:mm')}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                            {change?.modifiedBy?.displayName || change.practitioner?.displayName || 'Online'}
                        </TableCell>
                        <TableCell
                            className={classes.tableBodyCell}
                            style={{ whiteSpace: 'pre-line', ...clickableStyle }}
                            onClick={() => {
                                if (canEdit && isEditableNote) {
                                    handleNoteClick(noteType, noteId, change.description);
                                }
                            }}
                        >
                            {change.description}
                        </TableCell>
                    </TableRow>
                );
            })
            .reverse();
    };

    const showVoidOutstanding = useMemo(() => {
        if (!invoiceData) return false;
        if (invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.PAID) return false;

        // == instead of ===  because the expression returns a float
        // eslint-disable-next-line
        if (Math.abs(invoiceTotal - paymentTotal).toFixed(2) == 0) return false; // no outstanding

        if (invoiceData.relatedInvoices && invoiceData.relatedInvoices.length > 0) {
            // if there is some related invoice with refund
            return invoiceData.relatedInvoices.some(relatedInvoice => relatedInvoice.origin === INVOICE_ORIGIN.REFUND);
        }
        return false;
    }, [invoiceData, invoiceTotal, paymentTotal]);

    const handleVoidOutstanding = async () => {
        try {
            await invoiceApi.voidOutstandingAmount(invoice.id);
            toastr.success('Amount successfuly voided');
            await reload();
            if (listUpdate) {
                listUpdate();
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                return toastr.error(err.response.data.message);
            }

            toastr.error('Something went wrong');
        }
    };

    const [voidPopupDisabledButtons, setVoidPopupDisabledButtons] = useState(false);

    const calcInvoiceItemValues = useCallback(
        element => {
            const { netPrice, discount, quantity, tax, soldBy, refundedAmount } = element;
            const taxValue = 1 + (element?.tax || 0);
            const taxLabel = (element?.tax ?? 0) * 100 + '%';
            const isRefunded = invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.REFUND;

            const elementValue = () => {
                if (isRefunded) return refundedAmount;
                return quantity * netPrice + discount / taxValue;
            };

            // calculate unitary tax, using partial discounts for quantity > 1
            const unitaryTax = calculateTaxValue({
                tax,
                netPrice: elementValue() / quantity,
                quantity: 1
            });
            // calculate total gross price first, then remove tax and discount
            const netPriceLabel = () => {
                if (isRefunded) {
                    return roundTwoDecimals(refundedAmount / taxValue);
                }
                return roundTwoDecimals(netPrice + unitaryTax) * quantity - totalTax() + discount / taxValue;
            };

            const elementTotal = () => {
                if (isRefunded) return refundedAmount;
                return (
                    element.quantity *
                        (calculateTaxValue({
                            tax: element.tax,
                            netPrice: element.netPrice,
                            quantity: 1
                        }) +
                            element.netPrice) +
                    element.discount
                );
            };

            // calculate total taxes, using line total divided by tax rate
            const totalTax = () => {
                if (isRefunded) return refundedAmount - refundedAmount / taxValue;
                const lineTotal = elementTotal();
                const lineNet = roundTwoDecimals(lineTotal / taxValue);
                return roundTwoDecimals(lineTotal - lineNet);
            };

            const soldByLabel = soldBy ? element.soldBy?.displayName : '-';

            return {
                hasTax: taxValue !== 1,
                tax: taxLabel,
                totalTax: totalTax(),
                netPrice: netPriceLabel(),
                unitNetPrice: roundTwoDecimals(element.netPrice),
                grossPrice: roundTwoDecimals(element.netPrice * (1 + element.tax)) * element.quantity,
                elementTotal: elementTotal(),
                soldBy: soldByLabel
            };
        },
        // eslint-disable-next-line
        [invoiceData.items]
    );

    const TableBodyTotalPrice = (element, elementTotal) => {
        if (element.netPrice !== 0) {
            // eslint-disable-next-line no-constant-condition
            if (`${Math.round(parseFloat(element.tax), 10)}%`) {
                return toLocaleString(elementTotal);
            } else {
                return `${getCurrencySymbol()}0.00`;
            }
        } else {
            return `${getCurrencySymbol()}0.00`;
        }
    };

    const sendEmail = async (emailData = null) => {
        try {
            setIsLoading(true);
            await InvoiceApi.sendEmailInvoice(invoiceData.id, emailData || {});
            toastr.success('Invoice successfully sent');
            setShowSendEmailModal(false);
            await reload();
        } catch (err) {
            toastr.error('Something went wrong');
        } finally {
            setIsLoading(false);
        }
    };

    const hasRefundedInvoice = () => {
        if (invoiceData?.relatedInvoices?.length) {
            return !!invoiceData.relatedInvoices.find(ri => ri.paymentStatus === INVOICE_PAYMENT_STATUS.REFUND);
        }

        return false;
    };

    const canRefundInvoice = () => {
        return havePayments() && !hasRefundedInvoice();
    };

    const canVoidInvoice = () => {
        // verify as not allowed payment methods.
        const notAllowedPayments = (invoiceData?.payments || []).find(payment => {
            const hasAnyCardValue =
                payment?.cardBrand ||
                payment?.cardLast4 ||
                payment?.stripePaymentIntent ||
                payment?.stripePaymentId ||
                payment?.squarePaymentId;

            const isBlockedPaymentMethod = blockedEditPaymentMethods.includes(payment?.method);

            return hasAnyCardValue || isBlockedPaymentMethod;
        });

        const hasActiveDirectDebit =
            invoiceData?.directDebit?.coherentId && invoiceData?.directDebit?.status !== 'void';

        return (
            !notAllowedPayments &&
            !hasActiveDirectDebit &&
            !isRefundOrRelated &&
            invoiceData?.paymentStatus !== INVOICE_PAYMENT_STATUS.VOID
        );
    };

    const isRefundOrRelated = useMemo(() => {
        if (invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.REFUND) return true;
        if (invoiceData.relatedInvoices && invoiceData.relatedInvoices.length > 0) {
            // if there is some related invoice with refund
            return invoiceData.relatedInvoices.some(relatedInvoice => relatedInvoice.origin === INVOICE_ORIGIN.REFUND);
        }
    }, [invoiceData]);

    const canChangePaymentMethod = payment => {
        if (!payment?.method) return false;
        if (isRefundOrRelated) return false;

        // blocked payment methods.
        const isCardMethod = blockedEditPaymentMethods.includes(payment.method);

        // verify has any card information.
        const hasAnyCardValue =
            payment?.cardBrand ||
            payment?.cardLast4 ||
            payment?.stripePaymentIntent ||
            payment?.stripePaymentId ||
            payment?.squarePaymentId;

        return !isCardMethod && !hasAnyCardValue;
    };
    const paymentMethodFieldHandler = (value, id, reason) => {
        setEditPaymentMethodId(null);
        if (!value?.name || reason === 'clear') return false;

        const index = (newValues?.payments || []).findIndex(payment => payment.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const payments = [...prev.payments];
                payments[index].method = value.name;

                return {
                    ...prev,
                    payments
                };
            });
        }
    };
    const paymentTakenByFieldHandler = (value, id, reason) => {
        setEditPaymentTakenBy(null);
        if (!value?.id || reason === 'clear') return false;

        const index = (newValues?.payments || []).findIndex(payment => payment.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const payments = [...prev.payments];
                payments[index].takenBy = value;

                return {
                    ...prev,
                    payments
                };
            });
        }
    };
    const paymentAmountFieldHandler = (value, id) => {
        setEditPaymentAmountId(null);
        const index = (newValues?.payments || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const payments = [...prev.payments];
                payments[index].amount = parseFloat(value);

                return {
                    ...prev,
                    payments
                };
            });
        }
    };

    const paymentDateFieldHandler = (value, id) => {
        setEditPaymentDateId(null);
        const index = (newValues?.payments || []).findIndex(item => item.id === id);
        if (index !== -1) {
            setNewValues(prev => {
                const payments = [...prev.payments];
                payments[index].createdAt = value;

                return {
                    ...prev,
                    payments
                };
            });
        }
    };

    const soldByFieldHandler = (value, id) => {
        setEditSoldByItemId(null);
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                items[index].soldBy = value;

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const medicalFieldHandler = (value, id) => {
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                items[index].medical = value;

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const quantityFieldHandler = (value, id) => {
        setEditQuantityItemId(null);
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                items[index].quantity = value;

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const taxFieldHandler = (value, id) => {
        setEditTaxItemId(null);
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                const { elementTotal } = calcInvoiceItemValues(items[index]);
                items[index].tax = value;

                if (!elementTotal) {
                    items[index].netPrice = 0;
                } else {
                    const parsedValue = parseFloat(elementTotal);

                    if (parsedValue === 0) {
                        items[index].netPrice = 0;
                    } else if (parsedValue < 0) {
                        if (items[index]?.type === 'Void') {
                            items[index].netPrice = parsedValue;
                        } else {
                            items[index].netPrice = 0;
                        }
                    } else {
                        const tax = 1 + (value || 0);
                        const discount = Math.abs(items[index].discount || 0);
                        const quantity = items[index].quantity || 1;

                        let netPrice = (parsedValue + discount) / tax;
                        if (netPrice > 0) {
                            items[index].netPrice = parseFloat((netPrice / quantity).toFixed(2));
                        } else {
                            items[index].netPrice = 0;
                        }
                    }
                }

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const totalAmountFieldHandler = (value, id) => {
        setEditTotalItemId(null);
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];

                if (!value) {
                    items[index].netPrice = 0;
                } else {
                    const parsedValue = parseFloat(value);

                    if (parsedValue === 0) {
                        items[index].netPrice = 0;
                    } else if (parsedValue < 0) {
                        if (items[index]?.type === 'Void') {
                            items[index].netPrice = parsedValue;
                        } else {
                            items[index].netPrice = 0;
                        }
                    } else {
                        const tax = 1 + (items[index].tax || 0);
                        const discount = Math.abs(items[index].discount || 0);
                        const quantity = items[index].quantity || 1;

                        let netPrice = (parsedValue + discount) / tax;
                        if (netPrice > 0) {
                            items[index].netPrice = parseFloat((netPrice / quantity).toFixed(2));
                        } else {
                            items[index].netPrice = 0;
                        }
                    }
                }

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const unitPriceFieldHandler = (value, id) => {
        setEditUnitPriceItemId(null);
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                const parsedValue = parseFloat(value) || 0;

                if (parsedValue < 0 && items[index]?.type !== 'Void') {
                    return prev;
                }

                items[index].netPrice = parsedValue;

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const discountFieldHandler = (value, id, type, element) => {
        setEditDiscountItemId(null);
        setDiscountType('amount');
        const index = (newValues?.items || []).findIndex(item => item.id === id);

        if (index !== -1) {
            setNewValues(prev => {
                const items = [...prev.items];
                const parsedValue = parseFloat(value) || 0;

                let discountAmount;
                if (type === 'percent') {
                    // Calculate gross price (Sub Total inc Tax) for the element
                    const grossPrice = roundTwoDecimals(element.netPrice * (1 + element.tax)) * element.quantity;
                    // Calculate discount amount from percentage
                    discountAmount = roundTwoDecimals((parsedValue / 100) * grossPrice);
                } else {
                    discountAmount = parsedValue;
                }

                // Store as negative value (system convention)
                items[index].discount = -Math.abs(discountAmount);

                return {
                    ...prev,
                    items
                };
            });
        }
    };

    const renderPaymentMethodCell = (canEditPaymentMethod, element) => {
        if (canEdit && canEditPaymentMethod && editPaymentMethodId === element.id) {
            return (
                <Autocomplete
                    id="payment-method-autocomplete"
                    className={classes.editCellAutocomplete}
                    options={paymentOptions}
                    loadingText={'Loading...'}
                    clearText="Close"
                    defaultValue={(paymentOptions || []).find(option => option.name === element.method)}
                    getOptionLabel={option => option.label}
                    style={{ width: 200 }}
                    renderInput={params => (
                        <TextField {...params} label="" variant="outlined" className={classes.staffSelection} />
                    )}
                    onChange={(e, value, reason) => paymentMethodFieldHandler(value, element.id, reason)}
                />
            );
        }

        return (
            <div
                onClick={() => {
                    if (canEditPaymentMethod && canEdit && paymentOptions?.length) {
                        setEditPaymentMethodId(element.id);
                    }
                }}
            >
                {element.squarePaymentId ? (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://${
                            process.env.REACT_APP_ENVIRONMENT === 'production' ? 'squareup' : 'squareupsandbox'
                        }.com/dashboard/sales/transactions/${element.squarePaymentId}`}
                        style={{ color: '#0000EE', textDecoration: 'underline' }}
                    >
                        {element.method} {element.cardBrand && `${element.cardBrand} ${element.cardLast4}`}
                    </a>
                ) : (
                    <span>
                        {`${element.method} ${element.giftcardId ? '- ' + element.giftcardId.code : ''}`}{' '}
                        {element.cardBrand && `${element.cardBrand} ${element.cardLast4}`}
                    </span>
                )}
            </div>
        );
    };
    const renderPaymentTakenByCell = element => {
        if (canEdit && editPaymentTakenBy === element.id) {
            return (
                <Autocomplete
                    id="payment-takenby-autocomplete"
                    className={classes.editCellAutocomplete}
                    options={activePractitioners}
                    loadingText={'Loading...'}
                    clearText="Close"
                    defaultValue={(activePractitioners || []).find(option => option.id === element.takenBy?.id)}
                    getOptionLabel={option => option.displayName}
                    style={{ width: 200 }}
                    renderInput={params => (
                        <TextField {...params} label="" variant="outlined" className={classes.staffSelection} />
                    )}
                    onChange={(e, value, reason) => paymentTakenByFieldHandler(value, element.id, reason)}
                />
            );
        }

        return (
            <div
                onClick={() => {
                    if (canEdit && paymentOptions?.length) {
                        setEditPaymentTakenBy(element.id);
                    }
                }}
            >
                <span>{element.takenBy?.displayName || 'Online'}</span>
            </div>
        );
    };
    const renderPaymentAmountCell = (canEditPaymentMethod, element) => {
        const getNumericValue = value => {
            if (!value) {
                if (value === '') {
                    return value;
                } else {
                    return 0;
                }
            }

            return value;
        };

        return (
            <>
                {canEdit && canEditPaymentMethod && editPaymentAmountId === element.id ? (
                    <>
                        <EditableCell
                            defaultValue={getNumericValue(element.amount)}
                            onConfirm={value => paymentAmountFieldHandler(value, element.id)}
                            onCancel={() => {
                                setEditPaymentAmountId(null);
                            }}
                        >
                            {({ value, setValue }) => (
                                <>
                                    <TextField
                                        className={classes.editCellInput}
                                        value={value}
                                        type="number"
                                        variant="outlined"
                                        onChange={event => {
                                            const value = event.target.value;

                                            if (+value < 0) {
                                                toastr.error('Error', 'This value cannot be negative');
                                            } else {
                                                setValue(value);
                                            }
                                        }}
                                    />
                                </>
                            )}
                        </EditableCell>
                    </>
                ) : (
                    <div
                        onClick={() => {
                            if (canEditPaymentMethod && canEdit && paymentOptions?.length) {
                                setEditPaymentAmountId(element.id);
                            }
                        }}
                    >
                        {toLocaleString(element.amount)}
                    </div>
                )}
            </>
        );
    };

    const renderPaymentDateCell = (canEditPaymentMethod, element) => {
        return (
            <>
                {canEdit && editPaymentDateId === element.id ? (
                    <EditableCell
                        defaultValue={element.createdAt}
                        onConfirm={value => paymentDateFieldHandler(value, element.id)}
                        onCancel={() => {
                            setEditPaymentDateId(null);
                        }}
                        toLeft={true}
                    >
                        {({ value, setValue }) => (
                            <>
                                <DateTimePicker
                                    format="dd/MM/yyyy HH:mm"
                                    className={classes.editCellInput}
                                    value={value}
                                    okLabel={'Continue'}
                                    TextFieldComponent={props => <TextField {...props} variant="outlined" />}
                                    onChange={value => {
                                        setValue(value);
                                    }}
                                />
                            </>
                        )}
                    </EditableCell>
                ) : (
                    <div
                        onClick={() => {
                            setEditPaymentDateId(element.id);
                        }}
                    >
                        {Moment(element.createdAt).format('DD/MM/YYYY HH:mm')}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemSoldByCell = element => {
        const soldByLabel = element?.soldBy ? element.soldBy?.displayName : 'Online';
        return (
            <>
                {canEdit && editSoldByItemId === element.id ? (
                    <>
                        <Autocomplete
                            id="soldBy-autocomplete"
                            className={classes.editCellAutocomplete}
                            options={activePractitioners}
                            defaultValue={element.soldBy ? element.soldBy : null}
                            getOptionLabel={option => option.displayName}
                            style={{ width: 200 }}
                            renderInput={params => (
                                <TextField {...params} label="" variant="outlined" className={classes.staffSelection} />
                            )}
                            onChange={(e, newSoldBy) => {
                                soldByFieldHandler(newSoldBy, element.id);
                            }}
                        />
                    </>
                ) : (
                    <div
                        onClick={() => {
                            setEditSoldByItemId(element.id);
                        }}
                    >
                        {soldByLabel}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemMedicalCell = element => {
        return (
            <span
                title={element?.medical ? element?.medical : 'Not selected'}
                style={{
                    border: `1px solid ${MEDICAL_TYPES_COLOURS[element?.medical || 'NONE']}`,
                    borderRadius: 50,
                    display: 'inline-block',
                    width: 25,
                    height: 25,
                    textAlign: 'center',
                    fontWeight: 500,
                    paddingTop: 4,
                    color: 'white',
                    fontSize: 12,
                    backgroundColor: MEDICAL_TYPES_COLOURS[element?.medical || 'NONE']
                }}
                onClick={() => {
                    if (canEdit) {
                        const currentItemMedical = element?.medical;
                        let nextItemMedical = '';
                        if (currentItemMedical === '') {
                            nextItemMedical = MEDICAL_TYPES.COSMETIC.toUpperCase();
                        }
                        if (currentItemMedical === MEDICAL_TYPES.COSMETIC.toUpperCase()) {
                            nextItemMedical = MEDICAL_TYPES.MEDICAL.toUpperCase();
                        }
                        medicalFieldHandler(nextItemMedical, element.id);
                    }
                }}
            >
                {element.medical ? element.medical.substr(0, 1) : 'N'}
            </span>
        );
    };

    const renderInvoiceItemQuantityCell = element => {
        return (
            <>
                {canEdit && editQuantityItemId === element.id ? (
                    <>
                        <EditableCell
                            defaultValue={element.quantity}
                            onConfirm={value => quantityFieldHandler(value, element.id)}
                            onCancel={() => {
                                setEditQuantityItemId(null);
                            }}
                        >
                            {({ value, setValue }) => (
                                <>
                                    <TextField
                                        className={classes.editCellInput}
                                        value={value}
                                        type="number"
                                        variant="outlined"
                                        onChange={event => {
                                            const value = event.target.value;

                                            if (value < 0 && element?.type !== 'Void') {
                                                toastr.error('Error', 'This value cannot be negative');
                                            } else {
                                                setValue(value);
                                            }
                                        }}
                                        inputProps={{ style: { width: 80 } }}
                                    />
                                </>
                            )}
                        </EditableCell>
                    </>
                ) : (
                    <div
                        onClick={() => {
                            setEditQuantityItemId(element.id);
                        }}
                    >
                        {element.quantity}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemTaxCell = element => {
        return (
            <>
                {canEdit && editTaxItemId === element.id ? (
                    <>
                        <EditableCell
                            defaultValue={element.tax}
                            onConfirm={value => taxFieldHandler(value, element.id)}
                            onCancel={() => {
                                setEditTaxItemId(null);
                            }}
                        >
                            {({ value, setValue }) => (
                                <>
                                    <Select
                                        options={taxOptions}
                                        value={value}
                                        onChange={event => {
                                            const selectedValue = event.target.value;
                                            setValue(selectedValue);
                                        }}
                                        className={classes.editCellInput}
                                    >
                                        {taxOptions.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {/*<TextField*/}
                                    {/*    className={classes.editCellInput}*/}
                                    {/*    value={value}*/}
                                    {/*    type="number"*/}
                                    {/*    variant="outlined"*/}
                                    {/*    onChange={event => {*/}
                                    {/*        const value = event.target.value;*/}

                                    {/*        if (value < 0 && element?.type !== 'Void') {*/}
                                    {/*            toastr.error('Error', 'This value cannot be negative');*/}
                                    {/*        } else {*/}
                                    {/*            setValue(value);*/}
                                    {/*        }*/}
                                    {/*    }}*/}
                                    {/*/>*/}
                                </>
                            )}
                        </EditableCell>
                    </>
                ) : (
                    <div
                        onClick={() => {
                            setEditTaxItemId(element.id);
                        }}
                    >
                        {element.tax * 100 + '%'}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemTotalCell = (element, elementTotal) => {
        return (
            <>
                {canEdit && editTotalItemId === element.id && !isRefundOrRelated ? (
                    <EditableCell
                        defaultValue={elementTotal}
                        onConfirm={value => totalAmountFieldHandler(value, element.id)}
                        onCancel={() => {
                            setEditTotalItemId(null);
                        }}
                    >
                        {({ value, setValue }) => (
                            <>
                                <TextField
                                    className={classes.editCellInput}
                                    value={value}
                                    type="number"
                                    variant="outlined"
                                    onChange={event => {
                                        const value = event.target.value;

                                        if (value < 0 && element?.type !== 'Void') {
                                            toastr.error('Error', 'This value cannot be negative');
                                        } else {
                                            setValue(value);
                                        }
                                    }}
                                    inputProps={{ style: { width: 80 } }}
                                />
                            </>
                        )}
                    </EditableCell>
                ) : (
                    <div
                        onClick={() => {
                            if (canEdit) {
                                setEditTotalItemId(element.id);
                            }
                        }}
                    >
                        {TableBodyTotalPrice(element, elementTotal)}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemUnitPriceCell = (element, unitNetPrice) => {
        return (
            <>
                {canEdit && editUnitPriceItemId === element.id && !isRefundOrRelated ? (
                    <EditableCell
                        defaultValue={element.netPrice}
                        onConfirm={value => unitPriceFieldHandler(value, element.id)}
                        onCancel={() => {
                            setEditUnitPriceItemId(null);
                        }}
                    >
                        {({ value, setValue }) => (
                            <>
                                <TextField
                                    className={classes.editCellInput}
                                    value={value}
                                    type="number"
                                    variant="outlined"
                                    onChange={event => {
                                        const value = event.target.value;

                                        if (value < 0 && element?.type !== 'Void') {
                                            toastr.error('Error', 'This value cannot be negative');
                                        } else {
                                            setValue(value);
                                        }
                                    }}
                                    inputProps={{ style: { width: 80 } }}
                                />
                            </>
                        )}
                    </EditableCell>
                ) : (
                    <div
                        onClick={() => {
                            if (canEdit && !isRefundOrRelated) {
                                setEditUnitPriceItemId(element.id);
                            }
                        }}
                    >
                        {element.netPrice !== 0 ? toLocaleString(unitNetPrice) : `${getCurrencySymbol()}0.00`}
                    </div>
                )}
            </>
        );
    };

    const renderInvoiceItemDiscountCell = element => {
        const getDiscountDisplay = () => {
            if (element.discount === 0 || invoiceData.origin === 'REFUND') {
                return `${getCurrencySymbol()}0.00`;
            }
            const discountAmount = Math.abs(element.discount) || 0;
            const grossPrice = roundTwoDecimals(element.netPrice * (1 + element.tax)) * element.quantity;
            const discountPercent = grossPrice > 0 ? roundTwoDecimals((discountAmount / grossPrice) * 100) : 0;
            return `${toLocaleString(discountAmount)} (${discountPercent}%)`;
        };

        return (
            <>
                {canEdit && editDiscountItemId === element.id && !isRefundOrRelated ? (
                    <EditableCell
                        defaultValue={discountType === 'amount' ? Math.abs(element.discount) || 0 : 0}
                        onConfirm={value => discountFieldHandler(value, element.id, discountType, element)}
                        onCancel={() => {
                            setEditDiscountItemId(null);
                            setDiscountType('amount');
                        }}
                    >
                        {({ value, setValue }) => (
                            <Box display="flex" alignItems="center" style={{ gap: '4px' }}>
                                <Select
                                    value={discountType}
                                    onChange={e => {
                                        setDiscountType(e.target.value);
                                        setValue(e.target.value === 'amount' ? Math.abs(element.discount) || 0 : 0);
                                    }}
                                    variant="outlined"
                                    className={classes.discountTypeSelect}
                                >
                                    <MenuItem value="amount">{getCurrencySymbol()}</MenuItem>
                                    <MenuItem value="percent">%</MenuItem>
                                </Select>
                                <TextField
                                    className={classes.editCellInput}
                                    value={value}
                                    type="number"
                                    variant="outlined"
                                    onChange={event => {
                                        setValue(event.target.value);
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: discountType === 'percent' ? 100 : undefined,
                                        style: { width: 80 }
                                    }}
                                />
                            </Box>
                        )}
                    </EditableCell>
                ) : (
                    <div
                        onClick={() => {
                            if (canEdit && !isRefundOrRelated && invoiceData.origin !== 'REFUND') {
                                setEditDiscountItemId(element.id);
                                setDiscountType('amount');
                            }
                        }}
                    >
                        {getDiscountDisplay()}
                    </div>
                )}
            </>
        );
    };

    const tableInvoicePaymentsData = useMemo(() => {
        return canEdit && !_.isEmpty(newValues) ? newValues.payments : invoiceData.payments;
    }, [canEdit, newValues, invoiceData]);

    const tableInvoiceItemsData = useMemo(() => {
        return canEdit && !_.isEmpty(newValues) ? newValues.items : invoiceData.items;
    }, [canEdit, newValues, invoiceData]);

    const canShowOutstandingAmount = () => {
        if (!canEdit) return invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.PART_PAID;
        return true;
    };

    const canShowPaymentLink = () => {
        return [INVOICE_PAYMENT_STATUS.PART_PAID, INVOICE_PAYMENT_STATUS.UNPAID].includes(invoiceData.paymentStatus);
    };

    const canShowDirectDebit = () => {
        return (
            [INVOICE_PAYMENT_STATUS.PART_PAID, INVOICE_PAYMENT_STATUS.UNPAID].includes(invoiceData.paymentStatus) &&
            source === 'calendar' &&
            (!invoiceData?.directDebit?.coherentId || invoiceData?.directDebit?.status === 'void')
        );
    };

    return (
        <Dialog
            open={(source === 'calendar' ? invoice.isInvoiceModalOpen : true) && invoiceData && practitionerList}
            maxWidth="1000"
            className={classes.dialogLarge}
            disableEscapeKeyDown={true}
            disableBackdropClick={true}
            onClose={handleClose}
        >
            {isLoading && <LoadingScreen />}
            <div ref={componentRef} className="invoice">
                <DialogTitle align="center">
                    <Box width="100%" style={{ display: 'none' }} className="logo-container">
                        <img
                            alt="logo"
                            style={{ maxHeight: '200px', maxWidth: '100%' }}
                            src={invoiceData?.organization?.logo}
                        />
                    </Box>
                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <Box display="flex" flexDirection="column" width="100%">
                            <span className={`${classes.fontSize18px} ${classes.title}`}>
                                {canEdit ? 'Edit' : ''} Invoice #{invoiceData.originalCode || invoiceData.code}{' '}
                                {!!(
                                    invoiceData.version &&
                                    invoiceData.versionSentToXero &&
                                    invoiceData.version &&
                                    invoiceData.versionSentToXero
                                ) && (
                                    <img
                                        alt="Synced with xero"
                                        src="/images/xero.png"
                                        style={{ height: 43, paddingBottom: 5, verticalAlign: 'middle' }}
                                    />
                                )}
                            </span>
                            <span
                                className={
                                    [INVOICE_PAYMENT_STATUS.UNPAID, INVOICE_PAYMENT_STATUS.PART_PAID].includes(
                                        invoiceData?.paymentStatus
                                    ) && classes.fontRed
                                }
                            >
                                {invoiceData?.paymentStatus?.toUpperCase()}
                                {[INVOICE_PAYMENT_STATUS.UNPAID, INVOICE_PAYMENT_STATUS.PART_PAID].includes(
                                    invoiceData?.paymentStatus
                                ) && unpaidPaymentLink
                                    ? ' - Payment link sent'
                                    : ''}
                                {[INVOICE_PAYMENT_STATUS.UNPAID, INVOICE_PAYMENT_STATUS.PART_PAID].includes(
                                    invoiceData?.paymentStatus
                                ) &&
                                invoiceData?.directDebit?.status !== 'void' &&
                                invoiceData?.directDebit?.coherentId
                                    ? ` - Direct Debit ${invoiceData?.directDebit?.numberOfPayments} x £${invoiceData?.directDebit?.amount}`
                                    : ''}
                            </span>
                            <span>
                                {invoiceData?.referencedInvoice ? (
                                    <>
                                        Refund of original invoice{' '}
                                        <Button
                                            onClick={() => {
                                                setReferenceInvoice(invoiceData.id);
                                                openInvoice(invoiceData.referencedInvoice.id);
                                            }}
                                        >
                                            {invoiceData.referencedInvoice.originalCode ||
                                                invoiceData.referencedInvoice.code}
                                        </Button>
                                    </>
                                ) : (
                                    ''
                                )}
                            </span>
                        </Box>
                        <IconButton className={`${classes.closeButton} close-button`} onClick={() => handleClose()}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Box display="flex" justifyContent="space-between" className={classes.box}>
                        <Box display="flex" flexDirection="column">
                            <Typography className={classes.marginTop8px}>
                                Date: {Moment(invoiceData?.date).format('DD/MM/YYYY')}
                            </Typography>
                            {source === 'calendar' && (
                                <Typography className={classes.marginTop8px}>
                                    Name: {invoiceData.customerData && getCustomerName(invoiceData.customerData[0])}
                                </Typography>
                            )}
                            <Typography className={classes.marginTop8px}>
                                Closed by: {invoiceData.closedBy && invoiceData.closedBy?.displayName}
                            </Typography>
                            {source !== 'calendar' && (
                                <Typography className={classes.marginTop8px}>
                                    Customer: {invoiceData.customerData && getCustomerName(invoiceData.customerData[0])}
                                </Typography>
                            )}
                        </Box>
                        <Box display="flex" alignItems="flex-end">
                            {source === 'calendar' && (
                                <div className="options-button">
                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        color="primary"
                                        className={classes.button}
                                        onClick={event => setAnchorEl(event.currentTarget)}
                                        disabled={myClinics.map(c => c.id).includes(invoiceData.clinic) === false}
                                    >
                                        Options
                                    </Button>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleCloseMenu}
                                        className={classes.optionsMenu}
                                    >
                                        {(invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.PART_PAID ||
                                            invoiceData.paymentStatus === INVOICE_PAYMENT_STATUS.UNPAID) && (
                                            <MenuItem
                                                onClick={() => {
                                                    window.open(
                                                        `${
                                                            JSON.parse(localStorage.getItem('linkCache')).posUrl
                                                        }/sale?invoice=${invoiceData.id}`,
                                                        '_blank'
                                                    );
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Take Payment
                                            </MenuItem>
                                        )}
                                        {canShowPaymentLink() && (
                                            <MenuItem
                                                onClick={() => {
                                                    setPaymentLinkModel(true);
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Send payment link
                                            </MenuItem>
                                        )}
                                        {canShowDirectDebit() && (
                                            <MenuItem
                                                onClick={() => {
                                                    setShowDirectDebitModal(true);
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Create Direct Debit
                                            </MenuItem>
                                        )}
                                        <MenuItem
                                            onClick={() => {
                                                changeEdit(canEdit);
                                                handleCloseMenu();
                                                setEditPaymentAmountId(null);
                                                setEditPaymentMethodId(null);
                                                setEditPaymentTakenBy(null);
                                            }}
                                        >
                                            {!canEdit ? 'Edit invoice' : 'Cancel'}
                                        </MenuItem>
                                        {!canEdit && (
                                            <MenuItem
                                                onClick={() => {
                                                    changeEdit(true);
                                                    handleCloseMenu();
                                                    setEditPaymentAmountId(null);
                                                    setEditPaymentMethodId(null);
                                                    setEditPaymentTakenBy(null);
                                                }}
                                            >
                                                {!canEdit ? 'Edit payment' : 'Cancel'}
                                            </MenuItem>
                                        )}
                                        <MenuItem
                                            onClick={() => {
                                                setShowSendEmailModal(true);
                                                handleCloseMenu();
                                            }}
                                        >
                                            Email to client
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setModifiedsLogModel(true);
                                                handleCloseMenu();
                                            }}
                                        >
                                            Invoice log
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handlePrint();
                                                handleCloseMenu();
                                            }}
                                        >
                                            Print
                                        </MenuItem>
                                        {showVoidOutstanding && (
                                            <MenuItem
                                                onClick={() => {
                                                    setVoidOsPopupOpen(true);
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Void OS amount
                                            </MenuItem>
                                        )}
                                        {canRefundInvoice() && (
                                            <MenuItem
                                                className={classes.fontRed}
                                                onClick={() => {
                                                    handleRefund();
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Refund
                                            </MenuItem>
                                        )}
                                        {canVoidInvoice() && (
                                            <MenuItem
                                                className={classes.fontRed}
                                                onClick={() => {
                                                    setVoidPopupOpen(true);
                                                    handleCloseMenu();
                                                }}
                                            >
                                                Void
                                            </MenuItem>
                                        )}
                                        {isXeroConnected && (
                                            <MenuItem
                                                onClick={() => {
                                                    handleResendToXero();
                                                    handleCloseMenu();
                                                }}
                                            >
                                                {!invoiceData.versionSentToXero ? 'Sync to Xero' : 'Re-sync to Xero'}
                                            </MenuItem>
                                        )}
                                    </Menu>
                                </div>
                            )}
                            {source === 'reporting' && isXeroConnected && (
                                <div className="options-button">
                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        color="primary"
                                        className={classes.button}
                                        onClick={event => setAnchorEl(event.currentTarget)}
                                        disabled={myClinics.map(c => c.id).includes(invoiceData.clinic) === false}
                                    >
                                        Options
                                    </Button>

                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleCloseMenu}
                                        className={classes.optionsMenu}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                handleResendToXero();
                                                handleCloseMenu();
                                            }}
                                        >
                                            {!invoiceData.versionSentToXero ? 'Sync to Xero' : 'Re-sync to Xero'}
                                        </MenuItem>
                                    </Menu>
                                </div>
                            )}
                        </Box>
                    </Box>
                    <Box>
                        <Typography className={classes.boldFont}>Invoice Items</Typography>
                        <Table className={classes.table} size="medium" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {itemsHeader.map((element, index) => {
                                        if (!isVat0Only && element.name === 'Medical') {
                                            return '';
                                        }
                                        return (
                                            <TableCell
                                                key={`${index}-items-header`}
                                                className={`${classes.tableHeader} ${
                                                    element.name === 'Medical' ? 'app-only' : ''
                                                }`}
                                                align={element.numeric ? 'right' : 'left'}
                                            >
                                                {element.name === 'Medical' ? '' : element.name}
                                            </TableCell>
                                        );
                                    })}
                                    {canEdit && !isRefundOrRelated && (
                                        <TableCell className={classes.tableHeader} align="center" />
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(tableInvoiceItemsData || [])?.map((element, index) => {
                                    const {
                                        totalTax,
                                        // netPrice,
                                        elementTotal,
                                        unitNetPrice,
                                        grossPrice
                                    } = calcInvoiceItemValues(element);
                                    return (
                                        <TableRow key={`${index}-item-table`} className={classes.tableRow}>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${canEdit ? 'editable' : ''}`}
                                            >
                                                {renderInvoiceItemSoldByCell(element)}
                                            </TableCell>
                                            <TableCell className={classes.tableBodyCell}>
                                                {element.name}
                                                {element.isRedemption && (
                                                    <>
                                                        <br />
                                                        <b>- Redeemed</b>
                                                    </>
                                                )}
                                                {element.description && (
                                                    <>
                                                        <br />
                                                        {element.description}
                                                    </>
                                                )}
                                            </TableCell>
                                            {isVat0Only && (
                                                <TableCell
                                                    className={`${classes.tableBodyCell} ${
                                                        canEdit ? 'editable' : ''
                                                    } app-only`}
                                                    style={{ textAlign: 'end' }}
                                                >
                                                    {renderInvoiceItemMedicalCell(element)}
                                                </TableCell>
                                            )}
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isRefundOrRelated ? 'editable' : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderInvoiceItemQuantityCell(element)}
                                            </TableCell>

                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isRefundOrRelated ? 'editable' : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderInvoiceItemUnitPriceCell(element, unitNetPrice)}
                                            </TableCell>

                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isRefundOrRelated ? 'editable' : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderInvoiceItemTaxCell(element)}
                                            </TableCell>

                                            <TableCell className={classes.tableBodyCell} style={{ textAlign: 'end' }}>
                                                {element.netPrice !== 0 ? toLocaleString(grossPrice) : '-'}
                                            </TableCell>

                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isRefundOrRelated && invoiceData.origin !== 'REFUND'
                                                        ? 'editable'
                                                        : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderInvoiceItemDiscountCell(element)}
                                            </TableCell>

                                            {/*<TableCell className={classes.tableBodyCell} style={{ textAlign: 'end' }}>*/}
                                            {/*    {element.netPrice !== 0 ? toLocaleString(netPrice) : '-'}*/}
                                            {/*</TableCell>*/}

                                            <TableCell className={classes.tableBodyCell} style={{ textAlign: 'end' }}>
                                                {element.netPrice === 0 ? '-' : toLocaleString(totalTax)}
                                            </TableCell>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isRefundOrRelated ? 'editable' : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderInvoiceItemTotalCell(element, elementTotal)}
                                            </TableCell>
                                            {canEdit && !isRefundOrRelated && (
                                                <TableCell
                                                    className={classes.tableBodyCell}
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleDeleteItem(element.id)}
                                                    >
                                                        <DeleteOutlineOutlinedIcon color="error" />
                                                    </IconButton>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box mt={2} display="flex" justifyContent="space-between" alignItems="flex-start">
                        <Box flex="0 0 50%" minWidth={0} mr={2}>
                            <Typography className={classes.boldFont}>Invoice notes:</Typography>
                            <Box ml={1} className="app-only" style={{ wordBreak: 'break-word' }}>
                                {RenderShortNotes()}
                            </Box>
                            <Box ml={1} className="print-only" style={{ wordBreak: 'break-word' }}>
                                {RenderPrintNotes()}
                            </Box>
                            {canEdit && (
                                <Box mt={1}>
                                    <TextField
                                        multiline
                                        label="New note"
                                        value={newInvoiceNote}
                                        className={classes.notesInput}
                                        rows="4"
                                        margin="normal"
                                        onChange={e => setNewInvoiceNote(e.target.value)}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Box>
                            )}
                            <Box>
                                <Typography>{invoiceData.temporaryDiscount?.name || ''}</Typography>
                            </Box>
                        </Box>
                        <Box
                            display="flex"
                            flexDirection="column"
                            textAlign="right"
                            className={classes.invoiceDetails}
                            flexShrink={0}
                        >
                            <Typography>
                                Total ex Tax:
                                <span>
                                    {toLocaleString(
                                        invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.VOID && !canEdit
                                            ? 0
                                            : invoiceSubTotal
                                    )}
                                </span>
                            </Typography>
                            <Typography className={classes.marginTop8px}>
                                Tax:
                                <span>
                                    {toLocaleString(
                                        invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.VOID && !canEdit
                                            ? 0
                                            : invoiceTax
                                    )}
                                </span>
                            </Typography>
                            <Typography className={`${classes.boldFont} ${classes.marginTop8px}`}>
                                Total:
                                <span>
                                    {toLocaleString(
                                        invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.VOID && !canEdit
                                            ? 0
                                            : parseFloat(invoiceTotal.toFixed(2))
                                    )}
                                </span>
                            </Typography>
                            {invoiceDiscount !== 0 && invoiceData.origin !== 'REFUND' && (
                                <Typography className={classes.marginTop8px}>
                                    Inc Discount:
                                    <span>
                                        {toLocaleString(
                                            invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.VOID && !canEdit
                                                ? 0
                                                : Math.abs(invoiceDiscount)
                                        )}
                                    </span>
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box mt={canEdit ? 3 : 5}>
                        <Box>
                            <Typography className={classes.boldFont}>Payment</Typography>
                        </Box>
                        <Table className={classes.table} size="medium" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {paymentsHeader
                                        .filter(el => (canEdit ? true : !!el.name))
                                        .map((element, index) => {
                                            return (
                                                <TableCell
                                                    key={`${index}-payments-header`}
                                                    className={classes.tableHeader}
                                                    align={element.numeric ? 'right' : 'left'}
                                                >
                                                    {element.name}
                                                </TableCell>
                                            );
                                        })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(tableInvoicePaymentsData || [])?.map((element, index) => {
                                    const canUpdatePaymentMethod = canChangePaymentMethod(element);
                                    const isCardMethod = blockedEditPaymentMethods.includes(element.method);

                                    return (
                                        <TableRow key={`${index}-payment-table`} className={classes.tableRow}>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && !isCardMethod ? 'editable' : ''
                                                }`}
                                            >
                                                {renderPaymentDateCell(!isCardMethod, element)}
                                            </TableCell>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${canEdit ? 'editable' : ''}`}
                                            >
                                                {renderPaymentTakenByCell(element)}
                                            </TableCell>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && canUpdatePaymentMethod && paymentOptions?.length
                                                        ? 'editable'
                                                        : ''
                                                }`}
                                            >
                                                {renderPaymentMethodCell(canUpdatePaymentMethod, element)}
                                            </TableCell>
                                            <TableCell
                                                className={`${classes.tableBodyCell} ${
                                                    canEdit && canUpdatePaymentMethod ? 'editable' : ''
                                                }`}
                                                style={{ textAlign: 'end' }}
                                            >
                                                {renderPaymentAmountCell(canUpdatePaymentMethod, element)}
                                            </TableCell>
                                            {canEdit && canUpdatePaymentMethod && (
                                                <TableCell
                                                    className={`${classes.tableBodyCell}`}
                                                    style={{ textAlign: 'end', width: '30px' }}
                                                >
                                                    <IconButton
                                                        style={{ color: 'red' }}
                                                        className={`${classes.deleteIcon}`}
                                                        onClick={() => {
                                                            setNewValues(prev => {
                                                                const payments = [...prev.payments].filter(
                                                                    el => el.id !== element.id
                                                                );
                                                                const paymentsRemoved = prev.paymentsRemoved
                                                                    ? [...prev.paymentsRemoved]
                                                                    : [];
                                                                paymentsRemoved.push(element.id);

                                                                return {
                                                                    ...prev,
                                                                    payments,
                                                                    paymentsRemoved
                                                                };
                                                            });
                                                        }}
                                                    >
                                                        <DeleteOutlineOutlinedIcon />
                                                    </IconButton>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                        <Box mt={2} display="flex" flexDirection="column" alignItems="flex-end" mb={1.5}>
                            <Typography className={classes.boldFont}>
                                Total:{' '}
                                {toLocaleString(
                                    invoiceData?.paymentStatus === INVOICE_PAYMENT_STATUS.VOID && !canEdit
                                        ? 0
                                        : paymentTotal
                                )}
                            </Typography>
                            {canShowOutstandingAmount() && (
                                <Typography className={`${classes.boldFont} ${classes.fontRed}`}>
                                    OUTSTANDING: {toLocaleString(invoiceTotal - paymentTotal)}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box>
                        <Typography className={`${classes.centered} ${classes.font14}`}>
                            {getClinicDetails()}
                        </Typography>
                    </Box>
                    {canEdit && (
                        <Box mt={1} className={classes.buttonsBox}>
                            <Button className={classes.cancelBtn} onClick={changeEdit}>
                                Cancel
                            </Button>
                            <Button className={classes.button} onClick={updateInvoice} disabled={disabledButton}>
                                Save
                            </Button>
                        </Box>
                    )}
                </DialogContent>
            </div>
            <CancelContinueModal
                open={voidPopupOpen}
                title="Void Invoice"
                contentHtml={
                    '<p>Are you sure you want to void this invoice and associated payments?</p><br />' +
                    '<p style="text-align: left;padding-left: 20px;">If you void this invoice:</p><ul style="padding-left: 20px;">' +
                    '<li><p style="text-align: left;">any account items it contains will be removed from the client’s account.</p></li>' +
                    '<li><p style="text-align: left;">any products will have their stock adjusted (if you are using stock control).</p></li>' +
                    '<li><p style="text-align: left;">any courses will be voided.</p></li>' +
                    (invoiceData?.items?.find(el => el.type === 'Course')
                        ? '<li><p style="text-align: left;">any future services booked from this course will no longer be connected to it. They will become single services.</p></li>'
                        : '') +
                    (invoiceData?.directDebit?.status
                        ? '<li><p style="text-align: left;">any Direct Debit created to pay this invoice will be cancelled.</p></li>'
                        : '') +
                    '</ul>'
                }
                onContinue={() => {
                    setVoidPopupDisabledButtons(true);
                    handleUpdateVoid().then(() => {
                        closeInvoiceModal();
                        setVoidPopupDisabledButtons(false);
                        setVoidPopupOpen(false);
                        handleCloseMenu();
                    });
                }}
                onCancel={() => {
                    setVoidPopupOpen(false);
                    setVoidPopupDisabledButtons(false);
                }}
                closeOnBlur
                disableButtons={voidPopupDisabledButtons}
            />
            <CancelContinueModal
                open={voidOsPopupOpen}
                title="Void Invoice"
                contentHtml={'<p>Are you sure you want to void OS amount?</p>'}
                onContinue={() => {
                    handleVoidOutstanding().then(() => {
                        closeInvoiceModal();
                        setVoidOsPopupOpen(false);
                        handleCloseMenu();
                    });
                }}
                cancelButtonText={'Back'}
                continueButtonText={'Void OS amount'}
                onCancel={() => {
                    setVoidOsPopupOpen(false);
                    handleCloseMenu();
                }}
                closeOnBlur
            />
            <Dialog open={deleteLastItemWarning} onClose={() => setDeleteLastItemWarning(false)} maxWidth="sm">
                <DialogTitle style={{ textAlign: 'center' }}>
                    <Typography style={{ fontSize: '14px' }}>
                        It is not possible to remove all items from an invoice that has a payment against it
                    </Typography>
                </DialogTitle>
                <DialogContent style={{ display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
                    <Button className={classes.button} onClick={() => setDeleteLastItemWarning(false)}>
                        Close
                    </Button>
                </DialogContent>
            </Dialog>
            <Dialog
                open={modifiedsLogModel}
                className={classes.dialog}
                onBackdropClick={() => setModifiedsLogModel(false)}
                onEscapeKeyDown={() => setModifiedsLogModel(false)}
            >
                <Box minWidth={500} minHeight={500}>
                    <DialogTitle>
                        <Typography align="center">
                            <b className={`${classes.fontSize18px} ${classes.title}`}>Invoice Log</b>
                        </Typography>
                    </DialogTitle>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {changeLogHeader.map((head, i) => {
                                    return (
                                        <TableCell className={classes.tableHeader} key={i}>
                                            {head.name}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>{RenderLogTableRows()}</TableBody>
                    </Table>
                </Box>
                <IconButton className={classes.closeButton} onClick={() => setModifiedsLogModel(false)}>
                    <CloseIcon />
                </IconButton>
            </Dialog>
            {paymentLinkModel && (
                <PaymentLinkDialog
                    setPaymentLinkModel={setPaymentLinkModel}
                    amount={totalOutstandingAmount}
                    invoiceId={invoiceData.id}
                />
            )}

            {showDirectDebitModal && (
                <DirectDebitModal
                    showDirectDebitModal={showDirectDebitModal}
                    setShowDirectDebitModal={setShowDirectDebitModal}
                    amount={totalOutstandingAmount}
                    invoiceId={invoiceData.id}
                    reload={reload}
                />
            )}
            {showSendEmailModal && (
                <SendInvoiceEmailModal
                    onClose={() => setShowSendEmailModal(false)}
                    onSend={sendEmail}
                    customer={invoiceData.customerData?.[0]}
                    invoiceCode={invoiceData.code}
                    invoiceId={invoiceData.id}
                />
            )}
            <EditNoteModal
                isOpen={editNoteModalOpen}
                onClose={() => {
                    setEditNoteModalOpen(false);
                    setEditingNote(null);
                }}
                onUpdate={handleNoteUpdate}
                initialValue={editingNote?.description}
                noteType={editingNote?.noteType}
                noteId={editingNote?.noteId}
            />
        </Dialog>
    );
};

InvoiceModal.propTypes = {
    classes: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired,
    closeInvoiceModal: PropTypes.func.isRequired,
    loadInvoice: PropTypes.func.isRequired,
    source: PropTypes.string,
    listUpdate: PropTypes.func,
    openRefundModal: PropTypes.func
};

export default withStyles(InvoiceModalStyles)(InvoiceModal);
